<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row align-items-end">
          <div class="col-sm-6">
            <h3 class="page-title mb-1">
              Dashboard (Admin)
              <small v-if="selectedUser" class="text-muted d-block">
                Viewing user: {{ selectedUser.name }} ({{
                  selectedUser.username
                }})
              </small>
            </h3>
            <ul class="breadcrumb mb-0">
              <li class="breadcrumb-item active">
                {{ selectedUser ? "By User" : "Global" }}
              </li>
            </ul>
          </div>
          <div class="col-sm-6 text-right">
            <div class="d-inline-flex">
              <select
                id="userFilter"
                class="form-control select"
                style="min-width: 280px"
              >
                <option value="">— All users —</option>
              </select>
              <div class="btn-group ml-2">
                <button
                  class="btn btn-white"
                  :class="{ 'btn-primary text-white': days === 7 }"
                  @click="changeDays(7)"
                >
                  7d
                </button>
                <button
                  class="btn btn-white"
                  :class="{ 'btn-primary text-white': days === 30 }"
                  @click="changeDays(30)"
                >
                  30d
                </button>
                <button
                  class="btn btn-white"
                  :class="{ 'btn-primary text-white': days === 90 }"
                  @click="changeDays(90)"
                >
                  90d
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- KPIs -->
      <div class="row">
        <div
          class="col-md-6 col-sm-6 col-lg-6 col-xl-3"
          v-for="k in kpiList"
          :key="k.label"
        >
          <div class="card dash-widget">
            <div class="card-body">
              <span class="dash-widget-icon"><i :class="k.icon"></i></span>
              <div class="dash-widget-info">
                <h3>{{ k.value }}</h3>
                <span>{{ k.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts Row 1 -->
      <div class="row">
        <div class="col-md-6 text-center">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <h3 class="card-title mb-0">Articles by Step</h3>
                <small class="text-muted">last {{ days }} days</small>
              </div>
              <div id="bar-by-step" style="height: 280px"></div>
            </div>
          </div>
        </div>
        <div class="col-md-6 text-center">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <h3 class="card-title mb-0">Articles Created / Day</h3>
                <small class="text-muted">last {{ days }} days</small>
              </div>
              <div id="line-created-per-day" style="height: 280px"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts Row 2 -->
      <div class="row">
        <div class="col-md-6 text-center">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <h3 class="card-title mb-0">By Site</h3>
                <small class="text-muted">last {{ days }} days</small>
              </div>
              <div id="donut-by-site" style="height: 280px"></div>
            </div>
          </div>
        </div>

        <!-- Top Authors chỉ hiện ở Global -->
        <div class="col-md-6 text-center" v-if="!selectedUser">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <h3 class="card-title mb-0">Top Authors</h3>
                <small class="text-muted">Top {{ topAuthorsLimit }}</small>
              </div>
              <div class="table-responsive">
                <table class="table table-striped mb-0">
                  <thead>
                    <tr>
                      <th style="width: 60%">Author</th>
                      <th class="text-right">Articles</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="a in statsGlobal.topAuthors" :key="a.authorId">
                      <td>{{ a.authorName || "#" + a.authorId }}</td>
                      <td class="text-right">{{ a.total }}</td>
                    </tr>
                    <tr
                      v-if="
                        !statsGlobal.topAuthors ||
                        statsGlobal.topAuthors.length === 0
                      "
                    >
                      <td colspan="2" class="text-center text-muted">
                        No data
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Recent -->
      <div class="row">
        <div class="col-md-12 d-flex">
          <div class="card card-table flex-fill">
            <div class="card-header">
              <h3 class="card-title mb-0">
                Recent Articles
                {{ selectedUser ? "(Selected User)" : "(Updated Global)" }}
              </h3>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table custom-table mb-0">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Step</th>
                      <th v-if="!selectedUser">Author</th>
                      <th>Site</th>
                      <th class="text-right">Updated At</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in recent" :key="r.id">
                      <td>{{ r.title || "#" + r.id }}</td>
                      <td>
                        <span class="badge badge-outline-primary">{{
                          prettyStep(r.step)
                        }}</span>
                      </td>
                      <td v-if="!selectedUser">
                        {{ r.authorName || "#" + r.authorId }}
                      </td>
                      <td>{{ r.selectedSiteId || "-" }}</td>
                      <td class="text-right">
                        {{ formatDateTime(r.updatedAt) }}
                      </td>
                    </tr>
                    <tr v-if="recent.length === 0">
                      <td
                        :colspan="selectedUser ? 4 : 5"
                        class="text-center text-muted"
                      >
                        No recent items
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <button class="btn btn-link" @click="reload()">Reload</button>
              <button
                class="btn btn-light ml-2"
                v-if="selectedUser"
                @click="clearUser()"
              >
                Clear user
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import api from "../api";

export default {
  name: "AdminDashboardView",
  data() {
    return {
      loading: true,
      error: null,
      days: 30,
      topAuthorsLimit: 5,
      selectedUser: null, // { id, name, username }
      statsGlobal: {
        total: 0,
        byStep: {},
        createdPerDay: [],
        bySite: [],
        topAuthors: [],
      },
      statsAuthor: { total: 0, byStep: {}, createdPerDay: [], bySite: [] },
      recent: [],
      chartBar: null,
      chartLine: null,
      chartDonut: null,
    };
  },
  computed: {
    kpiList() {
      const src = this.selectedUser ? this.statsAuthor : this.statsGlobal;
      const byStep = src.byStep || {};
      const total = Number(src.total || 0);
      const finalized = Number(byStep.FINALIZED || 0);
      const pushed = Number(byStep.PUSHED || 0);
      let others = 0;
      for (const [k, v] of Object.entries(byStep))
        if (k !== "FINALIZED" && k !== "PUSHED") others += Number(v || 0);
      return [
        {
          label: `${this.selectedUser ? "User" : "Articles"} (${this.days}d)`,
          value: total,
          icon: "fa fa-cubes",
        },
        { label: "Finalized", value: finalized, icon: "fa fa-check" },
        { label: "Pushed to WP", value: pushed, icon: "fa fa-upload" },
        { label: "In Progress", value: others, icon: "fa fa-hourglass-half" },
      ];
    },
  },
  mounted() {
    this.initUserSelect();
    this.reload();
  },
  beforeUnmount() {
    if (this.chartBar) this.chartBar.el.empty();
    if (this.chartLine) this.chartLine.el.empty();
    if (this.chartDonut) this.chartDonut.el.empty();
  },
  methods: {
    async reload() {
      if (this.selectedUser) {
        await Promise.all([this.fetchByAuthor(), this.fetchRecentByAuthor()]);
      } else {
        await Promise.all([this.fetchGlobal(), this.fetchRecentGlobal()]);
      }
    },
    changeDays(n) {
      this.days = n;
      this.reload();
    },
    clearUser() {
      this.selectedUser = null;
      const sel = $("#userFilter");
      sel.val("").trigger("change");
      this.reload();
    },

    // --------- API calls ----------
    async fetchGlobal() {
      try {
        this.loading = true;
        this.error = null;
        const { data } = await api.get("/api/articles/stats/global", {
          params: { days: this.days, top: this.topAuthorsLimit },
        });
        this.statsGlobal = data || {
          total: 0,
          byStep: {},
          createdPerDay: [],
          bySite: [],
          topAuthors: [],
        };
        this.renderCharts();
      } catch (e) {
        console.error(e);
        this.error = "Không tải được thống kê global.";
      } finally {
        this.loading = false;
      }
    },
    async fetchByAuthor() {
      try {
        if (!this.selectedUser) return;
        this.loading = true;
        this.error = null;
        const { data } = await api.get("/api/articles/stats/author", {
          params: { authorId: this.selectedUser.id, days: this.days },
        });
        this.statsAuthor = data || {
          total: 0,
          byStep: {},
          createdPerDay: [],
          bySite: [],
        };
        this.renderCharts();
      } catch (e) {
        console.error(e);
        this.error = "Không tải được thống kê theo user.";
      } finally {
        this.loading = false;
      }
    },
    async fetchRecentGlobal() {
      try {
        const { data } = await api.get("/api/articles/stats/recent", {
          params: { limit: 10 },
        });
        this.recent = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error(e);
        this.recent = [];
      }
    },
    async fetchRecentByAuthor() {
      try {
        if (!this.selectedUser) return;
        const { data } = await api.get("/api/articles/stats/recent/by-author", {
          params: { authorId: this.selectedUser.id, limit: 10 },
        });
        this.recent = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error(e);
        this.recent = [];
      }
    },

    // --------- Charts ----------
    renderCharts() {
      const src = this.selectedUser ? this.statsAuthor : this.statsGlobal;
      this.renderBarByStep(src.byStep);
      this.renderLineCreatedPerDay(src.createdPerDay);
      this.renderDonutBySite(src.bySite);
    },
    renderBarByStep(byStep) {
      const order = [
        "INIT",
        "SUB_KEYWORDS",
        "OUTLINE",
        "TITLE_DESCRIPTION",
        "SEMANTIC_KEYWORDS",
        "CONTENT",
        "FINALIZED",
        "PUSHED",
      ];
      const keys = Array.from(
        new Set([...order, ...Object.keys(byStep || {})])
      );
      const data = keys.map((k) => ({
        y: this.prettyStep(k),
        a: Number((byStep || {})[k] || 0),
      }));
      if (!this.chartBar) {
        this.chartBar = window.Morris.Bar({
          element: "bar-by-step",
          data,
          xkey: "y",
          ykeys: ["a"],
          labels: ["Articles"],
          barColors: ["#453a94"],
          lineWidth: "3px",
          resize: true,
          redraw: true,
        });
      } else {
        this.chartBar.setData(data);
      }
    },
    renderLineCreatedPerDay(rows) {
      const data = (rows || []).map((r) => ({
        y: r.day,
        a: Number(r.total || 0),
      }));
      if (!this.chartLine) {
        this.chartLine = window.Morris.Line({
          element: "line-created-per-day",
          data,
          xkey: "y",
          ykeys: ["a"],
          labels: ["Created"],
          lineColors: ["#f43b48"],
          lineWidth: "3px",
          resize: true,
          redraw: true,
          parseTime: false,
        });
      } else {
        this.chartLine.setData(data);
      }
    },
    renderDonutBySite(rows) {
      const data = (rows || []).map((s) => ({
        label: "Site #" + s.siteId,
        value: Number(s.total || 0),
      }));
      if (!this.chartDonut) {
        this.chartDonut = window.Morris.Donut({
          element: "donut-by-site",
          data,
          resize: true,
          colors: [
            "#453a94",
            "#f43b48",
            "#00b894",
            "#fdcb6e",
            "#0984e3",
            "#6c5ce7",
          ],
        });
      } else {
        this.chartDonut.setData(data);
      }
    },

    // --------- Utils ----------
    prettyStep(step) {
      const map = {
        INIT: "Init",
        SUB_KEYWORDS: "Sub Keywords",
        OUTLINE: "Outline",
        TITLE_DESCRIPTION: "Title+Desc",
        SEMANTIC_KEYWORDS: "Semantic KW",
        CONTENT: "Content",
        FINALIZED: "Finalized",
        PUSHED: "Pushed",
      };
      return map[step] || step;
    },
    formatDateTime(dt) {
      if (!dt) return "";
      const d = new Date(dt);
      return isNaN(d.getTime()) ? dt : d.toLocaleString();
    },

    // --------- Select2 (FIX: trả jqXHR) ----------
    // AdminDashboardView.vue
    initUserSelect() {
      const self = this;
      const BASE = process.env.VUE_APP_BASEURL;

      $("#userFilter")
        .select2({
          width: "100%",
          placeholder: "— All users —",
          allowClear: true,
          minimumInputLength: 0, // <-- cho phép tìm với chuỗi rỗng
          ajax: {
            url: BASE + "/api/nguoi-dung/options",
            dataType: "json",
            delay: 200,
            cache: true,
            data: (params) => ({ q: params.term || "", limit: 200 }),
            processResults: (data) => {
              const results = (data || []).map((u) => ({
                id: u.idNguoiDung,
                text: `${(u.hoTen || u.tenDangNhap) ?? ""} (${u.tenDangNhap})`,
                raw: {
                  id: u.idNguoiDung,
                  name: u.hoTen || u.tenDangNhap,
                  username: u.tenDangNhap,
                },
              }));
              return { results };
            },
            transport: function (params, success, failure) {
              return $.ajax({
                url: params.url,
                data: params.data,
                dataType: params.dataType,
                type: "GET",
                beforeSend: function (xhr) {
                  const token = localStorage.getItem("token");
                  if (token)
                    xhr.setRequestHeader(
                      "Authorization",
                      token.startsWith("Bearer ") ? token : `Bearer ${token}`
                    );
                },
              })
                .done(success)
                .fail(failure);
            },
          },
        })
        // Khi mở dropdown, ép Select2 trigger 'input' rỗng để gọi q=''
        .on("select2:open", () => {
          const $search = $(".select2-container--open .select2-search__field");
          if ($search.length) {
            $search.val(""); // rỗng
            $search.trigger("input"); // ép Select2 gọi AJAX với q=''
          }
        })
        .on("select2:select", (e) => {
          const item = e.params.data.raw;
          self.selectedUser = item;
          self.reload();
        })
        .on("select2:clear", () => self.clearUser());
    },
  },
};
</script>
